import { getInfo } from '@Components/Grid/components/Table/formatters';
import { formatters } from '@Components/hierarchical-report/utils';

export default function EntriesFormatter({ info, confirmed }) {
  const { value, row } = getInfo(info)

  return formatters.drilldownDB(formatters.newTabDrilldownDB, {
    label: value,
    pathname: "/subscriptions",
    params: { contestId: row.id, confirmed },
  })
}
